import { datadogRum } from "@datadog/browser-rum";
import React, { useEffect, createContext } from "react";

import { ReactChildren } from "../types/react";

export const MonitoringContext = createContext({});

// Datadog RUM is opt-in and controlled by its own flag so it can be enabled
// independently per environment.
export const isDatadogEnabled = (): boolean => process.env.REACT_APP_ENABLE_DATADOG === "true";

export const MonitoringProvider = ({ children }: ReactChildren): JSX.Element => {
  useEffect(() => {
    const datadogApplicationId = process.env.REACT_APP_DD_APPLICATION_ID;
    const datadogClientToken = process.env.REACT_APP_DD_CLIENT_TOKEN;

    // Init only when Datadog is enabled and creds are configured for this
    // environment's org. Without valid creds the RUM intake rejects every
    // request with a 403 (surfaced as a misleading CORS error).
    if (isDatadogEnabled() && datadogApplicationId && datadogClientToken) {
      datadogRum.init({
        applicationId: datadogApplicationId,
        clientToken: datadogClientToken,
        site: process.env.REACT_APP_DD_SITE || "datadoghq.com",
        service: "kariko",
        env: process.env.REACT_APP_DD_ENV || process.env.REACT_APP_ENV || "local",
        version: process.env.REACT_APP_KARIKO_VERSION || process.env.npm_package_version,
        sampleRate: 100,
        // @ts-ignore
        sessionReplaySampleRate: Number(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLING || 0),
        trackInteractions: true,
        trackFrustrations: true,
        trackResources: true,
        trackLongTasks: true,
        allowedTracingOrigins: [/https:\/\/.*\.pipcare\.com/],
      });

      if (Number(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLING || 0) > 0) {
        datadogRum.startSessionReplayRecording();
      }
    }
  }, []);

  return <MonitoringContext.Provider value={{}}>{children}</MonitoringContext.Provider>;
};
